import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  language: 2,
};

const languageSlice = createSlice({
  name: "languageSlice",
  initialState,
  reducers: {
    setLanguage: (state, action) => {
      state.language = action.payload;
      return state;
    },
  },
});

export const { setLanguage } = languageSlice.actions;
export default languageSlice;
